import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { SessionDataService } from '../services/session-data/session-data.service';
import { SessionData } from './session-data';
import { switchMap } from 'rxjs/operators';
import { ConfigService } from 'src/app/shared/config';

@Injectable({
    providedIn: 'root'
})
export class SessionStateGuard implements CanActivate {
    config: any;

    constructor(
        private sessionService: SessionDataService,
        private router: Router,
        private configService: ConfigService) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let statusCode;
        let sessionData;
        this.sessionService.getSessionData()
            .pipe(
                switchMap((data) => of(sessionData = data)),
                switchMap((_) => this.configService.get())
            ).subscribe(config => {
                this.config = config;
                statusCode = this.processUrlPremission(sessionData, state, this.config);

                if (statusCode === true) {
                    return true;
                } else {
                    this.router.navigate(['/error']);
                    return false;
                }
            });
        return true;
    }

    processUrlPremission(sessionData: SessionData, state: RouterStateSnapshot, config: any) {
        let statusCode;

        if (state.url.includes('/confirmation')) {
            statusCode = sessionData && sessionData.isLoginOk && !sessionData.isConfirmed;
        } else if (state.url.includes('/login')) {
            statusCode = true;
        } else if (state.url.includes('/app')) {
            statusCode = true;
        } else if ((state.url.includes('/tpp-home') || state.url.includes('/tpp-popup-consult') || state.url.includes('/tpp-request-list'))
            && `${config.test_ambient}` === 'true') {
            statusCode = true;
        } else if (state.url.includes('http://')) {
            statusCode = true;
        } else {
            statusCode = false;
        }

        return statusCode ? statusCode : false;
    }

    // isValidLogin(sessionData: SessionData) {
    //    if (sessionData.need2FA) {
    //         return sessionData.isOtpOk;
    //    } else {
    //         return true;
    //    }
    // }
}
